<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.product_log">
  <div class="banner center" style="max-width:800px;" *ngIf="source">
    <div class="row_header freeze_height">
      <div class="row">
        <div class="col-6">
          <ngx-select [(ngModel)]="selectedProductLogStatus" [noAutoComplete]="true" [items]="source.statusSummary" [optionValueField]="'key'" [optionTextField]="'value'" (select)="onStatusSelect()">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <span>{{onGetText(1,option.data.key)}}</span>
              <span class="en">&nbsp;({{option.data.value}})&nbsp;</span>
            </ng-template>
          </ngx-select>
        </div>
        <div class="col-6">
          <button class="button_icon button_icon_color icon_adjust" [disabled]="iCurrentRow == 1" (click)="onGetLogDetail(1)">arrow_circle_left</button>
          <span class="en">&nbsp;{{iCurrentRow}}/{{iTotalCount}}&nbsp;</span>
          <button class="button_icon button_icon_color icon_adjust" [disabled]="iCurrentRow == iTotalCount" (click)="onGetLogDetail(2)">arrow_circle_right</button>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of source.details">
        <div class="col-6">
          <span [ngClass]="item.key == '6' || item.key == '7' ? 'left_sub' : 'label_left'">{{onGetText(2,0,item)}}</span>
        </div>
        <div class="col-6">
          <span [ngClass]="item.key == '2' ? item.v3 : 'en'">{{item.v1}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
